import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import popout_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/popout.svg';
import { img } from '@phi/components';
import { uid_popout_one_or_many } from '@features/popin-popout';
import PopoutTooltip from './PopoutTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const PopoutIcon = popout_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Popout';
        },

        disabled() {
            return this.state.editing_reference_sketches
                || (this.state.selected_faces_count === 0 && this.state.selected_edges_count === 0);
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_popout_one_or_many();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 4,
            active: false,
            id: 'popout-button',
            tippy: 'left',
            wrapperId: 'popout-wrapper',
            onClick: this.onClick,
            help: 'popout',
        }, {
            label: () => 'Popout',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(popout_svg, this.alt),
            tooltip: PopoutTooltip,
        });
    },
});
